import {isNil} from 'lodash'

export const mapPartCategoriesToOptions = (partCategories = []) => {
  if (isNil(partCategories) || partCategories.length === 0) return []
  return partCategories.map(partCategory => {
    return {
      id: partCategory.id,
      key: partCategory.id,
      label: partCategory.name,
    }
  })
}

export const getPartCategoriesByParent = (partCategoryId, partCategories) => {
  if (partCategories.length === 0)
    return null

  const partCategory = partCategories.find(partCategory => partCategory.id === partCategoryId)
  partCategories = partCategories.filter(category => category.id !== partCategoryId)
  if (partCategory === undefined)
    return null

  return [partCategory]
      .concat(getPartCategoriesByParent(partCategory.parentId, partCategories))
      .filter(breadcrumb => breadcrumb !== null)
}

export const buildBreadcrumbs = (partCategoryId, partCategories) => {
  let partCategoriesByParent = getPartCategoriesByParent(partCategoryId, partCategories)
  partCategoriesByParent = isNil(partCategoriesByParent) ? [] : partCategoriesByParent.reverse()

  const partCategoryNames = partCategoriesByParent.map(partCategory => partCategory.name)
  return partCategoryNames.join(' > ')
}

export const getPartCategoryNameBreadcrumbs = (partCategory, partCategories) => {
  return isNil(partCategory)
      ? ''
      : buildBreadcrumbs(partCategory.id, partCategories)
}